export const getAddressStateCode = (option) => option?.value || '';
